import React from 'react';
import * as Yup from "yup";
import { sortCaret } from "../../../../_metronic/_helpers";
import * as columnFormatters from "../../../../_metronic/layout/components/basePage/pages/objects-table/column-formatters";
import { Input } from "../../../../_metronic/_partials/controls";
import { SelectObjectsField } from "../../../../_metronic/layout/components/basePage/selectObjects/SelectObjectsField";
import { SelectStatus } from '../../customComponents/SelectStatus';


export const initObject = {
  id: undefined,
  title: "",
  auditPeriodId: 0,
  auditPeriodTitle: "",
  auditPlaceId: 0,
  auditPlaceTitle: "",
  provinceTitle: "",
  townTitle: "",
  auditFormTypeId: 0,
  auditFormTypeTitle: "",
  questionId: 0,
  questionTitle: "",
  answerType: 1,

  buildingId: null,
  buildingTitle: "",
  floorId: null,
  floorTitle: "",
  roomId: null,
  roomTitle: "",
  seatId: null,
  seatTitle: "",

  answerOfQuestionId: null,
  answerOfQuestionTitle: "",
  editorId: null,
  editorFullName: "",
  creatorId: null,
  creatorFullName: "",
  createAt: "",
  editedAt: "",

  enteredAnswer: "",
  status: ""
};

export const rowFormatter = (row, idx) => {
  if (row.status && row.status === "Completed") return "table-success";
  else if (row.status && row.status === "NotAllowed" || row.status === "NotCompleted") return "table-danger";
  else if (row.status && row.status === "EnableMustConfirm" || row.status === "MustConfirm") return "table-warning";
  else return "";
  // return row.trafficTypeCode && row.trafficTypeCode > 0 ?  : '';
};

export const editRowFormatter = (row, idx) => {
  // if (row.status === null || row.status === "NotCompleted") return "holiday-row-class";
  // else return "edited-row-class";
  // // return row.trafficTypeCode && row.trafficTypeCode > 0 ?  : '';
  if (row.status !== null && row.status !== "NotCompleted") return "edited-row-class";
  return "";
};

export const columns = [
  {
    dataField: "auditPlaceTitle",
    text: "پردیس / مرکز",
    sort: true,
    sortCaret: sortCaret,
  },

  {
    dataField: "auditPeriodTitle",
    text: "دوره ارزیابی",
    sort: true,
    sortCaret: sortCaret,
  },
  {
    dataField: "auditFormTypeTitle",
    text: "پرسشنامه",
    sort: false,
    sortCaret: sortCaret,
  },
  {
    dataField: "questionTitle",
    text: "پرسش",
    sort: false,
    sortCaret: sortCaret,
  },
  {
    dataField: "enteredAnswer",
    text: "پاسخ ثبت شده",
    sort: true,
    sortCaret: sortCaret,
  },
  {
    dataField: "status",
    text: "وضعیت پاسخ",
    sort: true,
    sortCaret: sortCaret,
    formatter: columnFormatters.AuditResultStatusColumnFormatter,
  },
  // {
  //   dataField: "buildingTitle",
  //   text: "بلوک",
  //   sort: true,
  //   sortCaret: sortCaret,
  // },
  // {
  //   dataField: "floorTitle",
  //   text: "طیقه",
  //   sort: true,
  //   sortCaret: sortCaret,
  // },
  // {
  //   dataField: "roomTitle",
  //   text: "اتاق",
  //   sort: true,
  //   sortCaret: sortCaret,
  // },
  // {
  //   dataField: "seatTitle",
  //   text: "تخت",
  //   sort: true,
  //   sortCaret: sortCaret,
  // },

];

export const placColumns = [
  {
    dataField: "title",
    text: "پردیس / مرکز",
    sort: true,
    sortCaret: sortCaret,
  },
  {
    dataField: "provinceTitle",
    text: "استان",
    sort: true,
    sortCaret: sortCaret,
  },
  {
    dataField: "townTitle",
    text: "شهر",
    sort: true,
    sortCaret: sortCaret,
  },
  {
    dataField: "auditPeriodTitle",
    text: "دوره ارزیابی",
    sort: true,
    sortCaret: sortCaret,
  },
  {
    dataField: "status",
    text: "وضعیت پرسشنامه ",
    sort: true,
    sortCaret: sortCaret,
    formatter: columnFormatters.AuditStatusColumnFormatter,
  },
  {
    dataField: "editorFullName",
    text: "تکمیل کننده",
    sort: true,
    sortCaret: sortCaret,
  },

  // {
  //   dataField: "auditFormTypeTitle",
  //   text: "پرسشنامه",
  //   formatter: columnFormatters.AuditFormsColumnFormatter,
  //   formatExtraData: {
  //     // openEditObjectPage: objectsUIProps.openEditObjectPage,
  //     // openDeleteObjectDialog: objectsUIProps.openDeleteObjectDialog,
  //   },
  //   classes: "text-right pr-0",
  //   headerClasses: "text-right pr-3",
  //   style: {
  //     minWidth: "100px",
  //   },
  // },
];

export const buildingColumns = [
  {
    dataField: "title",
    text: "بلوک",
    sort: true,
    sortCaret: sortCaret,
  },
  {
    dataField: "provinceTitle",
    text: "استان",
    sort: true,
    sortCaret: sortCaret,
  },
  {
    dataField: "townTitle",
    text: "شهر",
    sort: true,
    sortCaret: sortCaret,
  },
  {
    dataField: "auditPeriodTitle",
    text: "دوره ارزیابی",
    sort: true,
    sortCaret: sortCaret,
  },
  {
    dataField: "status",
    text: "وضعیت پرسشنامه ",
    sort: true,
    sortCaret: sortCaret,
    formatter: columnFormatters.AuditStatusColumnFormatter,
  },
  {
    dataField: "editorFullName",
    text: "تکمیل کننده",
    sort: true,
    sortCaret: sortCaret,
  },
  {
    dataField: "auditFormTypeTitle",
    text: "پرسشنامه",
    formatter: columnFormatters.AuditFormsColumnFormatter,
    formatExtraData: {
      // openEditObjectPage: objectsUIProps.openEditObjectPage,
      // openDeleteObjectDialog: objectsUIProps.openDeleteObjectDialog,
    },
    classes: "text-right pr-0",
    headerClasses: "text-right pr-3",
    style: {
      minWidth: "100px",
    },
  },
];

export const floorColumns = [
  {
    dataField: "title",
    text: "طیقه",
    sort: true,
    sortCaret: sortCaret,
  },
  {
    dataField: "provinceTitle",
    text: "استان",
    sort: true,
    sortCaret: sortCaret,
  },
  {
    dataField: "townTitle",
    text: "شهر",
    sort: true,
    sortCaret: sortCaret,
  },
  {
    dataField: "auditPeriodTitle",
    text: "دوره ارزیابی",
    sort: true,
    sortCaret: sortCaret,
  },
  {
    dataField: "status",
    text: "وضعیت پرسشنامه ",
    sort: true,
    sortCaret: sortCaret,
    formatter: columnFormatters.AuditStatusColumnFormatter,
  },
  {
    dataField: "editorFullName",
    text: "تکمیل کننده",
    sort: true,
    sortCaret: sortCaret,
  },
  {
    dataField: "auditFormTypeTitle",
    text: "پرسشنامه",
    formatter: columnFormatters.AuditFormsColumnFormatter,
    formatExtraData: {
      // openEditObjectPage: objectsUIProps.openEditObjectPage,
      // openDeleteObjectDialog: objectsUIProps.openDeleteObjectDialog,
    },
    classes: "text-right pr-0",
    headerClasses: "text-right pr-3",
    style: {
      minWidth: "100px",
    },
  },
];

export const roomColumns = [
  {
    dataField: "title",
    text: "اتاق",
    sort: true,
    sortCaret: sortCaret,
  },
  {
    dataField: "provinceTitle",
    text: "استان",
    sort: true,
    sortCaret: sortCaret,
  },
  {
    dataField: "townTitle",
    text: "شهر",
    sort: true,
    sortCaret: sortCaret,
  },
  {
    dataField: "auditPeriodTitle",
    text: "دوره ارزیابی",
    sort: true,
    sortCaret: sortCaret,
  },
  {
    dataField: "status",
    text: "وضعیت پرسشنامه ",
    sort: true,
    sortCaret: sortCaret,
    formatter: columnFormatters.AuditStatusColumnFormatter,
  },
  {
    dataField: "editorFullName",
    text: "تکمیل کننده",
    sort: true,
    sortCaret: sortCaret,
  },
  {
    dataField: "auditFormTypeTitle",
    text: "پرسشنامه",
    formatter: columnFormatters.AuditFormsColumnFormatter,
    formatExtraData: {
      // openEditObjectPage: objectsUIProps.openEditObjectPage,
      // openDeleteObjectDialog: objectsUIProps.openDeleteObjectDialog,
    },
    classes: "text-right pr-0",
    headerClasses: "text-right pr-3",
    style: {
      minWidth: "100px",
    },
  },
];

export const seatColumns = [
  {
    dataField: "title",
    text: "تخت",
    sort: true,
    sortCaret: sortCaret,
  },
  {
    dataField: "provinceTitle",
    text: "استان",
    sort: true,
    sortCaret: sortCaret,
  },
  {
    dataField: "townTitle",
    text: "شهر",
    sort: true,
    sortCaret: sortCaret,
  },
  {
    dataField: "auditPeriodTitle",
    text: "دوره ارزیابی",
    sort: true,
    sortCaret: sortCaret,
  },
  {
    dataField: "status",
    text: "وضعیت پرسشنامه ",
    sort: true,
    sortCaret: sortCaret,
    formatter: columnFormatters.AuditStatusColumnFormatter,
  },
  {
    dataField: "editorFullName",
    text: "تکمیل کننده",
    sort: true,
    sortCaret: sortCaret,
  },
  {
    dataField: "auditFormTypeTitle",
    text: "پرسشنامه",
    formatter: columnFormatters.AuditFormsColumnFormatter,
    formatExtraData: {
      // openEditObjectPage: objectsUIProps.openEditObjectPage,
      // openDeleteObjectDialog: objectsUIProps.openDeleteObjectDialog,
    },
    classes: "text-right pr-0",
    headerClasses: "text-right pr-3",
    style: {
      minWidth: "100px",
    },
  },
];

export const formFields = [
  {
    row: 1,
    list: [
      {
        name: "enteredAnswer",
        type: "text",
        component: Input,
        auditPlaceholder: "پاسخ",
        label: "پاسخ",
        rowIdx: 1,
        class: "col-lg-6"
      },
    ]
  },

];

export const otherFields = [
  // {
  //   name: "description",
  //   lable: "Description",
  //   type: "textarea",
  //   as: "textarea",
  //   rowOrder: 1,
  //   rowIdx: 1,
  //   class: "form-control"
  // },

];


export const newfilterFields = [
  // {
  //   name: "status",
  //   lable: "MODULES.GENERAL.STATUS",
  //   type: "select",
  //   list: [
  //     {
  //       value: "0",
  //       lable: "غیر مجاز",
  //     },
  //     {
  //       value: "1",
  //       lable: "فعال جهت تکمیل کردن",
  //     },
  //     {
  //       value: "2",
  //       lable: "ناقص و غیرفعال",
  //     },
  //     {
  //       value: "3",
  //       lable: "تایید نهایی و تکمیل شده",
  //     },

  //   ],
  //   component: SelectStatus
  // },
  {
    name: "title",
    lable: "MODULES.GENERAL.SEARCH",
    type: "text",
    list: [],
  },
  {
    name: "provinceId",
    lable: "استان",
    type: "component",
    list: [],
    component: (props) =>
      <SelectObjectsField api="api/province"
        reduxState="provinces"
        sname="provinceId"
        {...props} />
  },

];

export const newfilterInitialValues = {
  filter: {
    title: "",
    provinceId: 0,
    haveSaveAll: false
    // status: "",
  },
  sortOrder: "asc", // asc||desc
  sortField: "id",
  pageNumber: 1,
  pageSize: 10,

  whereClause: "",
  whereClauseParameters: [
  ],
  orderClause: "id desc ",
  skipCount: 0,
  takeCount: 10,
};

export const newprepareFilter = (queryParams, values) => {
  // const { status, title } = values;
  const { title, haveSaveAll, provinceId } = values;
  const newQueryParams = { ...queryParams };
  const filter = {};

  // Filter by status
  // filter.status = status !== "" ? +status : undefined;
  filter.provinceId = provinceId !== "" ? +provinceId : 0;
  filter.title = title;
  filter.haveSaveAll = false

  newQueryParams.filter = filter;

  // let whereClause = "title.contains(@0)"
  // const whereClauseParameters = [];
  // whereClauseParameters.push(title)

  let whereClause = ""
  const whereClauseParameters = [];

  var idx = 0;

  if (filter.title !== undefined && idx === 0) {
    whereClause = `title.contains(@${idx})`
    whereClauseParameters.push(filter.title)
    idx++;
  }
  else if (filter.title !== undefined && idx > 0) {
    whereClause = whereClause + ` and title.contains(@${idx})`
    whereClauseParameters.push(filter.title)
    idx++;
  }

  if (filter.provinceId > 0 && idx === 0) {
    whereClause = `provinceId=@${idx}`
    whereClauseParameters.push(filter.provinceId)
    idx++;
  }
  else if (filter.provinceId > 0 && idx > 0) {
    whereClause = whereClause + ` and provinceId=@${idx}`
    whereClauseParameters.push(filter.provinceId)
    idx++;
  }

  newQueryParams.whereClause = whereClause;
  newQueryParams.whereClauseParameters = whereClauseParameters;

  return newQueryParams;
};

export const filterFields = [
  {
    name: "auditPeriodId",
    lable: "دوره ارزیابی",
    type: "parentComponent",
    list: [],
    rowIdx: 1,
    component: (props) => (
      <SelectObjectsField
        api="api/AuditPeriod"
        reduxState="auditPeriods"
        sname="auditPeriodId"
        {...props}
      />
    ),
    relField: ["auditPlaceId", "auditFormTypeId", "buildingId", "floorId"],
    relValues: { auditPlaceId: 0, auditFormTypeId: 0, buildingId: 0, floorId: 0 },
  },
  {
    name: "auditFormTypeId",
    lable: "پرسشنامه",
    type: "selectComponent",
    list: [],
    rowIdx: 2,
    component: (props) => (
      <SelectObjectsField api="api/auditFormType"
        reduxState="auditFormTypes"
        sname="auditFormTypeId"
        {...props} />
    ),
    relField: [],
    relValues: {},
  },
  {
    name: "auditPlaceId",
    lable: "پردیس / مرکز",
    type: "parentComponent",
    list: [],
    rowIdx: 3,
    component: (props) => (
      <SelectObjectsField api="api/auditPlace"
        reduxState="auditPlaces"
        sname="auditPlaceId"
        {...props} />
    ),
    relField: ["buildingId", "floorId"],
    relValues: { buildingId: 0, floorId: 0 },
  },
  {
    name: "buildingId",
    lable: "بلوک",
    type: "parentComponent",
    list: [],
    rowIdx: 4,
    component: (props) => (
      <SelectObjectsField api="api/building"
        reduxState="auditBuildings"
        sname="buildingId"
        {...props} />
    ),
    relField: ["floorId"],
    relValues: { floorId: 0 },
  },
  {
    name: "floorId",
    lable: "طبقه",
    type: "parentComponent",
    list: [],
    rowIdx: 5,
    component: (props) => (
      <SelectObjectsField api="api/floor"
        reduxState="floors"
        sname="floorId"
        {...props} />
    ),
    relField: ["roomId"],
    relValues: { roomId: 0 },
  },
  {
    name: "roomId",
    lable: "اتاق",
    type: "selectComponent",
    list: [],
    rowIdx: 6,
    component: (props) => (
      <SelectObjectsField api="api/Room"
        reduxState="rooms"
        sname="roomId"
        {...props} />
    ),
    relField: [],
    relValues: {},
  },

];

// export const filterInitialValues = {
//   auditPeriodId: 0,
//   auditPlaceId: 0,
//   buildingId: 0,
//   floorId: 0,
//   roomId: 0,
//   auditFormTypeId: 0,
// };

export const filterInitialValues = {
  filter: {
    auditPeriodId: 0,
    auditPlaceId: 0,
    buildingId: 0,
    floorId: 0,
    roomId: 0,
    auditFormTypeId: 0,
  },
  sortOrder: "asc", // asc||desc
  sortField: "id",
  pageNumber: 1,
  pageSize: 10,

  whereClause: "",
  whereClauseParameters: [
  ],
  orderClause: "id desc ",
  skipCount: 0,
  takeCount: 10,
};


export const prepareFilter = (queryParams, values) => {
  const { auditPlaceId, auditPeriodId, buildingId, floorId, auditFormTypeId, roomId } = values;
  const newQueryParams = { ...queryParams };
  const filter = {};

  // Filter by auditPeriodId
  filter.auditPlaceId = auditPlaceId !== "" ? +auditPlaceId : 0;
  filter.auditPeriodId = auditPeriodId !== "" ? +auditPeriodId : 0;
  filter.auditFormTypeId = auditFormTypeId !== "" ? +auditFormTypeId : 0;
  filter.buildingId = buildingId !== "" ? +buildingId : 0;
  filter.floorId = floorId !== "" ? +floorId : 0;
  filter.roomId = roomId !== "" ? +roomId : 0;
  newQueryParams.filter = filter

  let whereClause = ""
  const whereClauseParameters = [];

  var idx = 0;


  if (filter.auditPlaceId > 0 && idx === 0) {
    whereClause = `auditPlaceId=@${idx}`
    whereClauseParameters.push(filter.auditPlaceId)
    idx++;
  }
  else if (filter.auditPlaceId > 0 && idx > 0) {
    whereClause = whereClause + ` and auditPlaceId=@${idx}`
    whereClauseParameters.push(filter.auditPlaceId)
    idx++;
  }

  if (filter.auditPeriodId > 0 && idx === 0) {
    whereClause = `auditPeriodId=@${idx}`
    whereClauseParameters.push(filter.auditPeriodId)
    idx++;
  }
  else if (filter.auditPeriodId > 0 && idx > 0) {
    whereClause = whereClause + ` and auditPeriodId=@${idx}`
    whereClauseParameters.push(filter.auditPeriodId)
    idx++;
  }

  if (filter.buildingId > 0 && idx === 0) {
    whereClause = `buildingId=@${idx}`
    whereClauseParameters.push(filter.buildingId)
    idx++;
  }
  else if (filter.buildingId > 0 && idx > 0) {
    whereClause = whereClause + ` and buildingId=@${idx}`
    whereClauseParameters.push(filter.buildingId)
    idx++;
  }

  if (filter.floorId > 0 && idx === 0) {
    whereClause = `floorId=@${idx}`
    whereClauseParameters.push(filter.floorId)
    idx++;
  }
  else if (filter.floorId > 0 && idx > 0) {
    whereClause = whereClause + ` and floorId=@${idx}`
    whereClauseParameters.push(filter.floorId)
    idx++;
  }

  if (filter.roomId > 0 && idx === 0) {
    whereClause = `roomId=@${idx}`
    whereClauseParameters.push(filter.roomId)
    idx++;
  }
  else if (filter.roomId > 0 && idx > 0) {
    whereClause = whereClause + ` and roomId=@${idx}`
    whereClauseParameters.push(filter.roomId)
    idx++;
  }

  if (filter.auditFormTypeId > 0 && idx === 0) {
    whereClause = `auditFormTypeId=@${idx}`
    whereClauseParameters.push(filter.auditFormTypeId)
    idx++;
  }
  else if (filter.auditFormTypeId > 0 && idx > 0) {
    whereClause = whereClause + ` and auditFormTypeId=@${idx}`
    whereClauseParameters.push(filter.auditFormTypeId)
    idx++;
  }


  // if (filter.allowed !== undefined) {
  //   whereClause = whereClause + " and allowed=@4"
  //   whereClauseParameters.push(filter.allowed === 0 ? false : true)
  // }

  newQueryParams.whereClause = whereClause;
  newQueryParams.whereClauseParameters = whereClauseParameters;

  return newQueryParams;
};


// Validation schema
export const ObjectEditSchema = Yup.object().shape({
  // title: Yup.string()
  //   .required("پر کردن فیلد الزامی است"),
  // auditPeriodId: Yup.number()
  //   .required("auditPeriodId is required"),
  // psp: Yup.number()
  //   .min(6, "6 is minimum")
  //   .max(18, "18 is maximum"),

});

